var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.typeComponent)?_c('i',{staticClass:"loading-basic",style:(_vm.size && { width:(_vm.size + "px"), height:(_vm.size + "px") })},[_c('keep-alive',[_c(_vm.typeComponent,{tag:"component",attrs:{"options":_vm.options}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }